import styled from "styled-components";

export const ExpandableRoot = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    outline: none;
    width: 100%;
`;
